import type { IconName } from "@netlify/ui";
import type { AlertMessage, AlertSharedProps, AlertState } from "./types";

const ICONS: Record<AlertState, IconName> = {
  error: "warning-round",
  warning: "warning-triangle",
  info: "info-round",
  success: "info-round",
  upgrade: "sparkles",
};

const getState = ({
  error,
  warning,
  info,
  success,
  upgrade,
}: Partial<AlertSharedProps>): AlertState => {
  if (error) return "error";
  if (warning) return "warning";
  if (info) return "info";
  if (success) return "success";
  if (upgrade) return "upgrade";

  return "error";
};

export const parseProps = ({
  error,
  warning,
  info,
  success,
  upgrade,
  role = error ? "alert" : "status",
  iconName,
}: Partial<AlertSharedProps>): {
  message: AlertMessage;
  role: string;
  state: AlertState;
  icon: IconName;
} => {
  const message = error ?? warning ?? info ?? success ?? upgrade ?? "";

  const state = getState({ error, warning, info, success, upgrade });

  return {
    message,
    role,
    state,
    icon: iconName ?? ICONS[state],
  };
};
